<template>
  <div :class="s.partnerWrap">
    <div :class="s.topImgs">
      <img v-for="(item, index) in topImgs" :src="item" alt="" :key="index" />
    </div>
    <div :class="s.companyImgs">
      <img v-for="(item, index) in companyImgs" :src="item" alt="" :key="index" />
    </div>
  </div>
</template>

<script>
const topImgs = [
  require("../images/ic_logo_transparent.png"),
  require("../images/partner.png")
];
const companyImgs = [
  require("../images/pinan.png"),
  require("../images/renshou.png"),
  require("../images/taipingyang.png"),
  require("../images/picc.png"),
  require("../images/ccic.png"),
  require("../images/ssic.png"),
  require("../images/tpic.png"),
  require("../images/cpic.png"),
];
export default {
  computed: {
    s() {
      return this.$style;
    },
  },
  data() {
    return {
      topImgs,
      companyImgs
    };
  },
};
</script>

<style scoped lang="less" module>
.partnerWrap {
  width: 100%;
  background-color: #fff;
  overflow: hidden;
  margin-top: 60px;

  .topImgs {
    display: flex;
    justify-content: center;
    min-width: 1075px;

    img {
      height: 64px;
    }
  }

  .companyImgs {
    display: flex;
    justify-content: center;
    min-width: 1075px;
    margin-top: 10px;

    img {
      height: 48px;
      margin: 0 8px;
    }
  }
}
</style>
